import Vue from 'vue'
import Router from 'vue-router'
import Top from '@/components/Pages/Top'
import Downloads from '@/components/Pages/Downloads'
import DownloadLogos from '@/components/Pages/DownloadLogos'
import ZoomBackgrounds from '@/components/Pages/ZoomBackgrounds'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top,
      meta: { title: '', desc: 'ノバセルのブランドアセットをダウンロードしたり、使用する際に注意すべき点を知ることができます' }
    },
    {
      path: '/downloads/',
      name: 'Downloads',
      component: Downloads,
      children: [
        {
          path: 'logos',
          component: DownloadLogos,
          meta: { title: 'ロゴダウンロード', desc: 'ノバセルのロゴアセットをダウンロードできます' }
        },
        {
          path: 'zoom',
          component: ZoomBackgrounds,
          meta: { title: 'ZOOM壁紙ダウンロード', desc: 'ノバセル公式のZOOM壁紙をダウンロードできます' }
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js